import { KeyValuePair } from '../models';

export type InterpolationType =
    'linear'
    | 'linear-closed'
    | 'step'
    | 'step-before'
    | 'step-after'
    | 'basis'
    | 'basis-open'
    | 'basis-closed'
    | 'bundle'
    | 'cardinal'
    | 'cardinal-open'
    | 'cardinal-closed'
    | 'monotone';

export const Interpolation: KeyValuePair<string, string>[] = [
    { key: 'linear', value: 'Linear' },
    { key: 'linear-closed', value: 'Linear (closed)' },
    { key: 'step', value: 'Step' },
    { key: 'step-before', value: 'Step before' },
    { key: 'step-after', value: 'Step after' },
    { key: 'basis', value: 'B-spline' },
    { key: 'basis-open', value: 'B-spline (open)' },
    { key: 'basis-closed', value: 'B-spline (closed)' },
    { key: 'bundle', value: 'B-spline (tension=0.7)' },
    { key: 'cardinal', value: 'Cardinal' },
    { key: 'cardinal-open', value: 'Cardinal (open)' },
    { key: 'cardinal-closed', value: 'Cardinal (closed)' },
    { key: 'monotone', value: 'Monotone cubic' }
];